import React from "react";
import "./style.scss";
import successIcon from "../../../assets/icons/successModalIcon.svg";

function SuccessModal({setModalOpen, title, desc, btnText}) {
  return (
    <div className="success_modal_overlay">
      <div className="success_modal_container successPopupContainer">
        <div className="success_modal_container_top popupMessageTopSection">
          <div className="tick_icon popupIcon">
            <img
              src={successIcon}
              alt="successful tick"
            />
          </div>
        </div>

        <div className="success_modal_container_bottom popupMessageBottomSection">
          <h1>{title}</h1>
          <p>{desc}&nbsp;Everything went great. Let’s continue</p>
          <button
            className="success_modal_close_btn"
            onClick={() => setModalOpen(false)}
          >
            {btnText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuccessModal;
